import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UtilsService } from './utils';
import { AlertService } from './alert.service';

const INTERNAL_SERVER_ERROR = 500;

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

  constructor(private alertService: AlertService,
              private utils: UtilsService) {
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(tap((event: HttpEvent<any>) => {},
      (err: any) => {
      if (err instanceof HttpErrorResponse) {
        /* TODO: Error handling with toast will come soon
         * const {error} = err;
         * error.type = 'danger';
         * this.utils.isEqual(err.status, INTERNAL_SERVER_ERROR) ? this.alertService.setMessage(error) : this.alertService.setMessage(null);
        */
      }
    }));
  }
}
